export default {
    data() {
        return {
            hasFile: false,
            // 上传成功标示
            uploadSuccess: false,
        }
    },
    methods: {
        getTemplate() {
            const { origin } = location
            const baseUrl = `${origin}/api_v3/studio/mock/object/data-template`
            const { objectId } = this
            if (objectId) {
                window.open(`${baseUrl}?objectId=${objectId}`)
            } else {
                window.open(baseUrl)
            }
        },
        uploadChange(file) {
            if (file && file.status === 'ready') {
                this.hasFile = true
            }
        },
        uploadRemove(file) {
            if (file) {
                this.hasFile = false
                this.uploadSuccess = false
            }
        },
    },
}
